export function randomShortId() {
    const arr = new Uint8Array(8);
    window.crypto.getRandomValues(arr);
    return arr.join('');
}
